import {CrudService} from '../services/';
import axios from "axios";

export const fetchCourseSections = (params = {}) => {
    return CrudService._get({
        url: `v1/course-sections`,
        params
    });
};

export const postCourseSections = (data) => {
    return CrudService._post({
        url: `v1/course-sections/add`,
        data
    });
};

export const putCourseSections = (data) => {
    return CrudService._put({
        url: `v1/course-sections/edit/${data.id}`,
        data
    });
};

export const deleteCourseSections = (data) => {
    return CrudService._delete({
        url: `v1/course-sections/delete/${data.id}`,
    });
};

export const postTopicCreateVideo = (id) => {
    return CrudService._post({
        url: `v1/course-sections/create-video/${id}`,
    });
};

export const postTopicSaveVideo = (data) => {
    return CrudService._post({
        url: `v1/course-sections/save-video/${data.id}`,
        data
    });
};

export const postTopicVideo = (item, data, setVideoProgress) => {
    const link = item.link;
    const url = 'https://' + link.address + link.path;
    const params = {
        api_format: 'json',
        key: link.query.key,
        token: link.query.token,
    }

    return axios({
        method: 'POST',
        url,
        params,
        data,
        onUploadProgress: function(progressEvent) {
            setVideoProgress(Math.round((progressEvent.loaded * 100) / progressEvent.total))
        }
    });
};